import {EventEmitter, Injectable} from '@angular/core';
import {AuthHttp} from '../auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/publishReplay';
import {Subscriber} from 'rxjs/Subscriber';
import {UserModel} from '../../models/UserModel';
import {Field} from '../../../form-builder/interfaces/Field';

@Injectable()
export class CurrentUserService {
  private url = `${environment.baseUrl}users/current`;
  public cachedUser: UserModel;
  private waitingOnUser = false;
  private httpObservableComplete = new EventEmitter();

  constructor(private http: AuthHttp) { }

  prefetchData() {
    this.waitingOnUser = true;
    this.http.get(this.url)
      .do(res => {
        this.cachedUser = new UserModel(res.json());
      })
      .subscribe(() => {
        this.httpObservableComplete.emit(this.cachedUser);
        this.waitingOnUser = false;
    });
  }

  public getCurrentUser(): Observable<UserModel> {
    return Observable.create((subscriber: Subscriber<UserModel>) => {
      if (this.cachedUser)
        subscriber.next(this.cachedUser);
      else if (this.waitingOnUser)
        this.httpObservableComplete.subscribe(res => subscriber.next(res));
      else {
        this.httpObservableComplete.subscribe(res => subscriber.next(res));
        this.prefetchData();
      }
    });
  }

  public updateTimezoneOffset() {
    return this.http.put(this.url + '/timezoneOffset', {timezoneOffset: new Date().getTimezoneOffset()});
  }

  public getReadableFields(): Promise<Field[]> {
    return this.http.get(this.url + '/fields')
        .map((res) => res.json()).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/current-user/current-user.service.ts